<script>
module.exports = {
  template : '#app-template',
  computed : {
    classObject : function() {
      var obj = {
        show : this.$store.state.loggedIn
      };

      obj[this.$route.name] = true;

      return obj;
    }
  },
  created : function() {
    if (this.classObject.show) {
      this.$store.dispatch('init');
    }
  }
};
</script>